import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static values = { path: String, scope: String }

  connect() {
    if (window.location.pathname !== this.pathValue) return
    if (this.hasFilterParams(window.location.search)) return

    const stored = sessionStorage.getItem(this.storageKey)
    if (!stored) return

    Turbo.visit(`${this.pathValue}?${stored}`, {
      action: 'replace'
    })
  }

  save() {
    const params = new URLSearchParams()

    for (const [key, value] of new FormData(this.element)) {
      if (key.startsWith('q[')) params.append(key, value)
    }

    sessionStorage.setItem(this.storageKey, params.toString())
  }

  hasFilterParams(search) {
    return Array.from(new URLSearchParams(search).keys()).some(key =>
      key.startsWith('q[')
    )
  }

  get storageKey() {
    return `filter-memory-${this.scopeValue}`
  }
}
